const MAPBOX_TOKEN = 'pk.eyJ1IjoiZHRlY3giLCJhIjoiY210MHZ5dGpnMDlrdDJ5cHVlNHdweGM0dSJ9.PIwyalWlzgRC3RZw7ngJAw';

export async function fetchAddressSuggestions(query, proximity = null) {
  if (!query || query.length < 2) return [];
  const proximityParam = proximity ? `&proximity=${proximity.lng},${proximity.lat}` : '';
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${MAPBOX_TOKEN}&types=address&country=us&autocomplete=true&fuzzyMatch=true&limit=5${proximityParam}`;
  try {
    const res = await fetch(url);
    if (!res.ok) { console.error('Mapbox error:', res.status); return []; }
    const data = await res.json();
    console.log('Mapbox results:', data.features?.length, 'for query:', query);
    return (data.features || []).map(f => {
      const ctx = f.context || [];
      return {
        label: f.place_name,
        street: `${f.address || ''} ${f.text || ''}`.trim(),
        city:  ctx.find(c => c.id.startsWith('place'))?.text || '',
        state: ctx.find(c => c.id.startsWith('region'))?.short_code?.replace('US-', '') || '',
        zip:   ctx.find(c => c.id.startsWith('postcode'))?.text || '',
      };
    });
  } catch (e) {
    console.error('Mapbox fetch failed:', e);
    return [];
  }
}
